<template>
  <div>
    <b-row class="mt-3">
      <b-col>
        <b-card bg-variant="light">
          <b-row>
            <b-col class="my-3">
              <b-input-group>
                <b-form-input
                  v-model="filter"
                  :placeholder="$t('globals.type_to_search')"
                />
                <b-input-group-append>
                  <b-btn
                    variant="warning"
                    :disabled="!filter"
                    @click="filter = ''"
                  >
                    {{ $t("globals.clear") }}
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="2" class="my-3">
              <b-form-select v-model="perPage" :options="perPageOptions" />
            </b-col>
          </b-row>
          <b-table
            class="mt-3"
            bordered
            small
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items="audits"
            :fields="fields"
            :filter="filter"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template v-slot:cell(created_at)="item">
              <div v-b-tooltip.hover :title="item.item.created_at">
                {{ item.item.created_at.substring(0, 10) }}
              </div>
            </template>
            <template v-slot:cell(action)="item">
              <div v-b-tooltip.hover :title="item.item.data">
                {{ item.item.action }}
              </div>
            </template>
          </b-table>
          <b-row v-if="audits.length > 0">
            <b-col md="6" class="my-1">
              <b-pagination
                :total-rows="audits.length"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
                :hide-goto-end-buttons="audits.length <= perPage"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    audits: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      sortBy: "created_at",
      sortDesc: true,
      filter: null,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30].map(n => ({text: `${n} ${this.$t("globals.per_page")}`,value: n})),
      fields: [
        {
          key: "id"
        },
        {
          key: "agent.full_name",
          label: this.$t("globals.agent")
        },
        {
          key: "action",
          label: this.$t("globals.action")
        },
        {
          key: "created_at",
          label: this.$t("globals.created"),
          sortable: true
        }
      ]
    };
  }
};
</script>
